import { CertificationBuilder } from '../certifications.types';

export const deleteCertification = (builder: CertificationBuilder) =>
  builder.mutation<void, number>({
    query: (candidateCertificationId) => ({
      url: `candidate-certifications/${candidateCertificationId}`,
      method: 'DELETE',
    }),
    invalidatesTags: () => [{ type: 'Certification' }],
  });
